import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataPagesList: [],
  dataPagesDetail: [],
  dataDocumentCategoriesList: [],
  loading: false,
  error: undefined,
};

const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchAllPagesList(state, action) {
      state.dataPagesList = action.payload;
      state.dataPagesDetail = [];
      state.error = undefined;
      state.loading = false;
    },
    fetchAllPagesDetail(state, action) {
      state.dataPagesDetail = action.payload;
      state.error = undefined;
      state.loading = false;
    },
    fetchAllDocumentCategoriesList(state, action) {
      state.dataDocumentCategoriesList = action.payload;
      state.error = undefined;
      state.loading = false;
    },
  },
});

export const documentActions = documentSlice.actions;

export default documentSlice.reducer;
